// src/App.jsx
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import Home from "./Home";
import Login from "./Login";
import Dashboard from "./Dashboard";
import ProtectedRoute from "./ProtectedRoute";
import Header from "./Header";
import Footer from "./Footer";
import About from "./pages/About";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import FAQ from "./pages/FAQ";
import Guide from "./pages/Guide";
import GuideDetail from "./pages/GuideDetail";
import Feedback from "./pages/Feedback";
import Pricing from "./Pricing";
import ForgotPassword from "./ForgotPassword";
import BusinessProfileCreation from './pages/BusinessProfileCreation';
import EditBanking from "./pages/EditBanking";
import EditBusiness from "./pages/EditBusiness";
import ManageBusinesses from './pages/ManageBusinesses';
import AdminRoute from './pages/AdminRoute';
import AdminBusinesses from './pages/AdminBusinesses';
import AdminLayout from './pages/admin/AdminLayout';
import AdminOverview from './pages/admin/AdminOverview';
import AdminUsers from './pages/admin/AdminUsers';
import AdminPayments from './pages/admin/AdminPayments';
import AdminCategories from './pages/admin/AdminCategories';
import ScrollToTop from "./ScrollToTop";

// Hidden foundation metadata; Object.freeze keeps this call in the production bundle.
// The result is discarded and never rendered or attached to application state.
Object.freeze({
  proverbs_16_3: "Commit to the Lord whatever you do, and he will establish your plans.",
  matthew_6_33: "But seek first his kingdom and his righteousness, and all these things will be given to you as well.",
  luke_16_10: "He that is faithful in that which is least is faithful also in much.",
  dedication: "May SnapConX be built and operated with faith, integrity, wisdom, and a commitment to serving others."
});

function AppWrapper() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  );
}

function App() {
  return (
    <div className="app-wrapper">
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/Privacy" element={<Privacy />} />
          <Route path="/FAQ" element={<FAQ />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/guide/:slug" element={<GuideDetail />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/create-business" element={<BusinessProfileCreation />} />
          <Route path="/edit-business/:businessId" element={<EditBusiness />} />
          <Route path="/edit-banking" element={<EditBanking />} />
          <Route path="/manage-businesses" element={<ManageBusinesses />} />
          <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
            <Route index element={<AdminOverview />} />
            <Route path="businesses" element={<AdminBusinesses />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="payments" element={<AdminPayments />} />
          </Route>
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default AppWrapper;
